import { VaccineRecordErrorVariant } from 'actions/pets/PetsErrors';
import { Pet } from 'types/Pet';

export interface PetsState {
    pet?: Pet;
    loading: boolean;
    status: PetsStatus;
    vaccineRecordError?: VaccineRecordErrorVariant;
}

export enum PetsStatus {
    Initial,

    SaveStart,
    SaveSuccess,

    Error
}
